import routerOptions0 from "/Users/sebasgona/sga/pinturas-granados/granados/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.2_@vue+compiler-sfc@3.5.25_cac@6.7.14_db0@_cvukev6a3n62iehx3yqgnlmtcy/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}